import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Spin, Radio } from 'antd';
import intl from 'react-intl-universal';

import { parseFen2Currency } from '@/utils/number';
import { initSettleInfo } from '@/redux/actions/bill/settle';
import Payment from '@/components/Payment';
import { PayWay } from '@/components/Payment/interface';

import commonStyles from '../common.module.scss';
import styles from './index.module.scss';

function Settlement(props) {
  const { resvNo, payedAmount, initPayTypes, settleInfoLoading, settleInfo } = props;

  const [useDeposit, setUseDeposit] = useState(1);

  const radioChange = (e) => {
    props.useDeposit(Boolean(e.target.value));
    props.initSettleInfo({
      resvNo,
      useDeposit: Boolean(e.target.value),
    });
    setUseDeposit(e.target.value);
  };

  useEffect(() => {
    return () => {
      setUseDeposit(1);
    };
  }, []);

  const renderSettleStats = (info) => {
    return (
      <ul className={styles['settlement-stats']}>
        {info.settleAmount >= 0 ? (
          <>
            <li>
              <label className="text-colon">{intl.get('bill_refund_should_refund_room_fee')}</label>
              <span>{parseFen2Currency(Math.abs(info.settleAmount))}</span>
            </li>
            <li>
              <label className="text-colon">{intl.get('bill_refund_should_refund_deposit')}</label>
              <span className="amount-unit">{parseFen2Currency(info.refundDeposit)}</span>
            </li>
          </>
        ) : (
          <>
            <li>
              <label className="text-colon">{intl.get('bill_settle_should_pay_room_fee')}</label>
              <span>{parseFen2Currency(Math.abs(info.settleAmount))}</span>
            </li>
            <li>
              <label className="text-colon">{intl.get('bill_refund_should_refund_deposit')}</label>
              <span className="amount-unit">
                {parseFen2Currency(info.refundDeposit)}
                {/* {Math.abs(info.settleAmount) >= info.payDeposit
                  ? transformPriceUnit(info.payDeposit, true, true)
                  : transformPriceUnit(info.refundDeposit, true, true)} */}
              </span>
            </li>
          </>
        )}
        {info.settleAmount < 0 && info.refundDeposit > 0 ? (
          <li>
            <label className="text-colon">{intl.get('bill_settle_deposit_offset_room_fee')}</label>
            <Radio.Group value={useDeposit} disabled={payedAmount > 0} onChange={radioChange}>
              <Radio value={1}>{intl.get('app_yes')}</Radio>
              <Radio value={0}>{intl.get('app_no')}</Radio>
            </Radio.Group>
          </li>
        ) : (
          ''
        )}
      </ul>
    );
  };

  const renderPayDesk = (info) => {
    // 先收房费后退押金 hack
    if (payedAmount > 0) {
      return (
        <dl className={styles['settlement-pay']}>
          <dt className={commonStyles['bill-block-title']}>{intl.get('bill_credit_cashier')}</dt>
          <dd className={styles['settlement-pay-amount']}>
            <label className="text-colon">{intl.get('bill_credit_account_receivable')}</label>
            <span className="amount-pay">{parseFen2Currency(Math.abs(info.waitPayment))}</span>
          </dd>
          <dd>
            <label className="text-colon">{intl.get('bill_settle_receive_result')}</label>
            <span>
              {intl.get('bill_settle_has_received')}
              <span style={{ marginLeft: 5 }}>{parseFen2Currency(Math.abs(payedAmount))}</span>
            </span>
          </dd>
          <dd className={styles['settlement-pay-amount']}>
            <label className="text-colon">
              {intl.get('bill_part_refund_avalible_refund_amount')}
            </label>
            <span className="amount-refund">
              {info.settleAmount > 0
                ? parseFen2Currency(Math.abs(info.settleAmount + info.refundDeposit))
                : parseFen2Currency(Math.abs(info.refundDeposit))}
            </span>
          </dd>
        </dl>
      );
    }

    // 直接结账
    if (info.waitPayment === 0 && info.settleAmount === 0 && info.refundDeposit === 0) {
      return null;
    }

    // 收款
    if (info.waitPayment < 0) {
      return (
        <dl className={styles['settlement-pay']}>
          <dt className={commonStyles['bill-block-title']}>{intl.get('bill_credit_cashier')}</dt>
          <dd className={styles['settlement-pay-amount']}>
            <label className="text-colon">{intl.get('bill_credit_account_receivable')}</label>
            <span className="amount-pay">{parseFen2Currency(Math.abs(info.waitPayment))}</span>
          </dd>
          <dd>
            <Payment
              excludePayWay={[PayWay.Fukuandan]}
              isInitPayTypes={initPayTypes}
              selectPayType={(type) => props.selectPayType(type)}
              resvNo={resvNo}
              setIdCardNo={(no) => props.setCertNo(no)}
              setWyuid={(uid) => props.setWyuid(uid)}
            />
          </dd>
        </dl>
      );
    }

    // 退款
    // 待支付金额为0，且应退押金大于0或应退房费大于0
    if (info.waitPayment === 0 && (info.refundDeposit > 0 || info.settleAmount > 0)) {
      return (
        <dl className={styles['settlement-pay']}>
          <dt className={commonStyles['bill-block-title']}>{intl.get('bill_credit_cashier')}</dt>
          <dd className={styles['settlement-pay-amount']}>
            <label className="text-colon">
              {intl.get('bill_part_refund_avalible_refund_amount')}
            </label>
            <span className="amount-refund">
              {info.settleAmount > 0
                ? parseFen2Currency(Math.abs(info.settleAmount + info.refundDeposit))
                : parseFen2Currency(Math.abs(info.refundDeposit))}
            </span>
          </dd>
        </dl>
      );
    }

    return null;
  };

  return (
    <div className={styles['settlement-wrapper']}>
      <Spin spinning={settleInfoLoading}>
        <dl className={commonStyles['bill-block']} style={{ marginTop: 24 }}>
          <dt className={commonStyles['bill-block-title']}>
            {intl.get('bill_part_settle_account_total')}
          </dt>
          <dd>
            <label className="text-colon">{intl.get('bill_part_settle_has_paid')}</label>
            <span>
              {parseFen2Currency(settleInfo.payAmount)}
              {settleInfo.ota ? (
                <span style={{ fontSize: 12, color: '#969799', marginLeft: 5 }}>
                  (
                  <label className="text-colon">
                    {intl.get('bill_part_settle_include_ota_advance')}
                  </label>
                  <span className="amount-hint" style={{ fontSize: 12 }}>
                    {parseFen2Currency(settleInfo.ota)}
                  </span>
                  )
                </span>
              ) : (
                ''
              )}
            </span>
          </dd>
          <dd>
            <label className="text-colon">{intl.get('bill_pre_settle_paid_deposit')}</label>
            <span>{parseFen2Currency(settleInfo.payDeposit)}</span>
          </dd>
          <dd>
            <label className="text-colon">{intl.get('bill_part_settle_has_consumed_total')}</label>
            <span>{parseFen2Currency(settleInfo.consumeAmount)}</span>
          </dd>
          <dd>
            <label className="text-colon">{intl.get('bill_part_settle_coupon_discount')}</label>
            <span>{parseFen2Currency(settleInfo.discountAmount)}</span>
          </dd>
        </dl>
        {renderSettleStats(settleInfo)}
      </Spin>
      {renderPayDesk(settleInfo)}
    </div>
  );
}

const mapStateToProps = (state) => {
  const { settleInfoLoading, settleInfo } = state.settle;
  return {
    settleInfoLoading,
    settleInfo,
  };
};

export default connect(mapStateToProps, { initSettleInfo })(Settlement);
